<div class="meeting-attendance-details">
  <h4 class="details-title">Distribución de asistencias</h4>

  @if (meetingAttendanceData().total_attendances === 0) {
    <p class="no-data">No hay datos de asistencias disponibles</p>
  } @else {
    <div class="meeting-attendance-items">
      <div class="meeting-attendance-item">
        <span>✅ Asistidas</span>
        <span>{{ meetingAttendanceData().total_assisted | number: '1.0-0' }}</span>
      </div>
      <div class="meeting-attendance-item">
        <span>🕐 Asistidas (tarde +5min)</span>
        <span class="text-yellow">{{ meetingAttendanceData().total_yes_but_late | number: '1.0-0' }}</span>
      </div>
      <div class="meeting-attendance-item">
        <span>📅 Perdidas (otra reunión)</span>
        <span class="text-blue">{{ meetingAttendanceData().total_on_another_meeting | number: '1.0-0' }} (no penaliza)</span>
      </div>
      <div class="meeting-attendance-item">
        <span>❌ No asistidas</span>
        <span class="text-warn">{{ meetingAttendanceData().total_no | number: '1.0-0' }}</span>
      </div>
      <div class="meeting-attendance-item">
        <span>🚨 No asistidas por fuerza mayor</span>
        <span class="text-blue">{{ meetingAttendanceData().total_force_majeure | number: '1.0-0' }} (no penaliza)</span>
      </div>
      <div class="meeting-attendance-item">
        <span>💅 No tenía que asistir</span>
        <span class="text-blue">{{ meetingAttendanceData().total_didnt_have_to_attend | number: '1.0-0' }} (no penaliza)</span>
      </div>
      <mat-divider></mat-divider>
      <div class="meeting-attendance-item">
        <span>Total de reuniones</span>
        <span>{{ meetingAttendanceData().total_attendances | number: '1.0-0' }}</span>
      </div>
    </div>
  }
</div>
